/**
 *
 * Priority1Badge
 *
 */

import React, { memo } from 'react';
import styled from 'styled-components';

import { COLORS } from '../../../../theme';
import Badge from '..';

const StyledBadge = styled(Badge)`
  &.MuiChip-root {
    color: ${COLORS.goldMetalicDark};
    background: ${COLORS.goldMetalicLight};
    border-color: ${COLORS.goldMetalic};
  }

  && .MuiSvgIcon-root {
    path {
      fill: ${COLORS.goldMetalic};
    }
  }
`;

function Priority1Badge(props) {
  return <StyledBadge label="1st Priority" {...props} />;
}

export default memo(Priority1Badge);
